import { render, staticRenderFns } from "./doclist.vue?vue&type=template&id=3f20fc50"
import script from "./doclist.vue?vue&type=script&lang=js"
export * from "./doclist.vue?vue&type=script&lang=js"
import style0 from "./doclist.vue?vue&type=style&index=0&id=3f20fc50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports